import React from 'react';
import { Box, Typography, withStyles } from '@material-ui/core';
import { lampDesktop, lampMobile } from 'assets/images/retail';
import useI18n from "evcharging/hooks/useI18n";

const RootBox = withStyles((theme) => ({
  root: {
    paddingTop: 40,
    paddingLeft: 50,
    backgroundImage: `url("${lampMobile}")`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPositionX: 10,
    height: 210,
    [theme.breakpoints.up('sm')]: {
      paddingTop: 110,
      paddingLeft: 100,
      backgroundImage: `url("${lampDesktop}")`,
      height: 493,
      backgroundPositionX: 0,
    },
  },
}))(Box);

const Header = withStyles((theme) => ({
  root: {
    fontSize: 20,
    fontWeight: 800,
    lineHeight: '120%',
    color: '#000',
    '& span': {
      color: '#F9C106',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: 28,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 36,
    },
  },
}))(Typography);

const SubHeader = withStyles((theme) => ({
  root: {
    width: '100%',
    fontSize: 16,
    fontWeight: 600,
    color: '#595959',
    lineHeight: '150%',
    marginTop: 19,
    [theme.breakpoints.up('sm')]: {
      fontSize: 18,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 22,
    },
  },
}))(Typography);

const RetailSlogan = () => {
  const { t } = useI18n();

  return (
    <RootBox>
      <Header>
        {t('compare-rates.title')}
      </Header>
      <SubHeader>
        {t('compare-rates.description')}
      </SubHeader>
    </RootBox>
  );
};

export default RetailSlogan;
